import Container from '@/components/Container';
import './style.css';
import { Link } from 'react-router-dom';
import Divider from '@/components/Divider';
import SubContainer from '@/components/Container/SubContainer';
import { Header } from './header';
import DailyBubble from './daily-bubble';
import TrendingThisWeek from './trending-this-week';
import WeeklyQuestions from './weekly-questions';
import Podcast from './podcast';
import Learn from './learn';
import Latests from './latests';
import { useKnowledgeHubStore } from '../knowledge-hub/page/store/useKnowledgeHubStore';
import { useDailyAnswerStore } from './weekly-questions/useDailyAnswer';
import { usePodcastStore } from '../podcast/store/usePodcastStore';
import { useHomeStore } from './useHome';
import { useEffect } from 'react';
import { Loading } from './loading.skeleton';
import Wildcards from './wildcards';

const DailyBubbleApp = () => {
  const { trendingResources, trendingResourcesLoading } = useKnowledgeHubStore();
  const { questions, questionLoading } = useDailyAnswerStore();
  const { latestPodcastEpisodes, loading: loadingPodcast } = usePodcastStore();
  const { page, fetchHomePage, loadingPage } = useHomeStore();

  useEffect(() => {
    fetchHomePage();
  }, [fetchHomePage]);

  if (!page || loadingPage) return <Loading />;

  const renderDivider = () => {
    return (
      <SubContainer>
        <Divider />
      </SubContainer>
    );
  };

  const renderTitle = (title: string, link?: string) => {
    return (
      <SubContainer className="mb-sh-15 flex  items-center justify-between">
        <h2 className=" font-larken !text-sh-md">{title}</h2>
        {link ? (
          <Link className="w-16 text-sh-xxxs font-bold" to={link}>
            View All
          </Link>
        ) : null}
      </SubContainer>
    );
  };

  return (
    <Container className="!gap-0 md:!gap-0">
      <SubContainer className="mt-sh-60 flex flex-col gap-[5px]">
        <Header />
      </SubContainer>
      <SubContainer>
        <Divider />
      </SubContainer>
      {renderTitle(page?.sections.yourDailyBubbleTitle || 'Your daily bubble')}
      <SubContainer className="md:flex md:gap-4">
        <DailyBubble />
      </SubContainer>
      <Wildcards renderTitle={() => renderTitle(page?.sections?.wildcardTitle || 'Wildcards')} />
      {(trendingResources.length !== 0 || trendingResourcesLoading) && renderDivider()}
      {trendingResources.length !== 0 && renderTitle(page?.sections.trendingThisWeekTitle || 'Trending this week')}
      <SubContainer className="md:grid md:grid-cols-3 md:gap-5">
        <TrendingThisWeek />
      </SubContainer>
      {(questions.length !== 0 || questionLoading) && renderDivider()}
      <SubContainer>
        <WeeklyQuestions
          yourWeeklyQuestionDescription={page?.sections?.yourWeeklyQuestionDescription}
          yourWeeklyquestionTitle={page?.sections.yourWeeklyquestionTitle || 'Weekly questions'}
          yourWeeklyQuestionOnboardingTitle={
            page?.sections?.yourWeeklyQuestionOnboardingTitle || 'How the weekly Questions works'
          }
          onboardingQuestionTitle={page?.onboardingQuestions?.title}
          onboardingQuestionDescription={page?.onboardingQuestions?.description}
          onboardingQuestionButtonLabel={page?.onboardingQuestions?.btnLabel}
        />
      </SubContainer>
      {(latestPodcastEpisodes.length !== 0 || loadingPodcast) && renderDivider()}
      {latestPodcastEpisodes.length !== 0 &&
        renderTitle(page?.sections.latestPodcastTitle || 'Listen to our podcast', '/podcast')}
      <SubContainer className="md:grid md:grid-cols-2 md:gap-4">
        <Podcast />
      </SubContainer>
      {renderDivider()}
      {renderTitle(page?.sections.learnTitle || 'Learn', '/learn')}
      <SubContainer>
        <Learn />
      </SubContainer>
      {renderDivider()}
      <SubContainer className="grid grid-cols-1 gap-sh-30 md:grid-cols-3">
        <Latests />
      </SubContainer>
    </Container>
  );
};

export default DailyBubbleApp;
